import React, {Component} from 'react';
import {any, element} from "prop-types";

var propTypes = {
    Condition: any,
    Alternative: element
}

export class Conditional extends Component {
    render() {
        const {
            props
        } = this;

        const {
            Condition,
            Alternative,
            children
        } = props;

        return Condition ? children: (Alternative || null);
    }
}

Conditional.propTypes = propTypes;

